import * as React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import App from './App';
import { checkSession, setSessionStatus } from './api/environment';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

Sentry.init({
  dsn:
    'https://5657d440ea734fc6bcbfd2467fa2e017@o109340.ingest.sentry.io/5420177',
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
  environment: process.env.REACT_APP_API_DOMAIN
});

function mount() {
  ReactDOM.render(<App />, document.getElementById('root'));
}

/**
 * Auth gate that runs BEFORE React (and therefore the router and any protected
 * GraphQL queries) mounts. When the initial URL is a protected route, we first
 * confirm the session belongs to a logged-in manager. If the server confirms
 * there is no manager session, we rewrite the URL to /login so the router
 * resolves the login page instead of /app — the protected queries (e.g.
 * App_Holder_Query) never fire unauthenticated, and the user never sees the app
 * render against a null manager.
 */
async function bootstrap() {
  const path = window.location.pathname;
  const isProtected = path === '/app' || path.startsWith('/app/');

  if (isProtected) {
    const isManager = (await checkSession()) === 'manager';
    // Seed the router guard's cache so it doesn't repeat the check.
    setSessionStatus(isManager ? 'loggedIn' : 'loggedOut');

    if (!isManager) {
      // Replace so the protected URL isn't left in history, carrying the
      // requested page through login (e.g. deep links from emails) so a
      // successful login can land on it.
      const redirect = window.location.pathname + window.location.search;
      window.history.replaceState(
        null,
        '',
        '/login?redirect=' + encodeURIComponent(redirect)
      );
    }
  }

  mount();
}

bootstrap();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
